import AppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import { APP_BAR_HEIGHT } from './sticky-nav.const';
import { TEXT_PRIMARY } from '../app.styles';

export const StyledAppBar = styled(AppBar)({
  backgroundColor: TEXT_PRIMARY,
  position: 'sticky',
  top: 0,
  width: '100%',
  '.MuiAppBar-root': {
    height: APP_BAR_HEIGHT,
    position: 'sticky',
    top: 0,
    width: '100%',
  },
  '.MuiToolbar-root': {
    height: APP_BAR_HEIGHT,
  },
});
